import { Button } from '@components/button';
import { useSaveChanges } from '@pages/QuoteDetails/helpers/useSaveChanges';
import { useUpdateQuote } from '@services/quotes';
import { PanelInstance } from '@store/Quote/Quote.types';
import { useCurrentQuoteStoreState } from '@store/Quote/QuoteStore';

export const CustomerSubmitButton = ({
  quoteId,
  panelInstances,
  variant,
}: {
  quoteId: string;
  variant: 'contained';
  panelInstances: PanelInstance[];
}) => {
  const { updateQuote, isPending: isUpdateQuoteLoading } = useUpdateQuote();
  const { saveChanges } = useSaveChanges(quoteId, panelInstances);

  const quoteStoreContext = useCurrentQuoteStoreState();
  return (
    <Button
      key='submit-quote'
      variant={variant}
      isLoading={isUpdateQuoteLoading}
      onClick={async () => {
        const { attributesById } = quoteStoreContext;
        const hasUnsavedChanges = Object.keys(attributesById).length > 0;

        if (hasUnsavedChanges) {
          await saveChanges();
        }
        updateQuote({
          quoteId,
          customerSubmittedOn: new Date().toISOString(),
        });
      }}
    >
      Submit for Quote
    </Button>
  );
};
